"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.manageTabIndex = exports.handleTokenizedString = exports.handleSlideFocus = exports.handleInactiveSwiperSlides = exports.getSlidesPerViewXL = exports.getSlidesPerViewSM = exports.getSlidesPerViewMD = exports.getSlidesPerViewLG = exports.getSlidesPerGroupXL = exports.getSlidesPerGroupSM = exports.getSlidesPerGroupMD = exports.getSlidesPerGroupLG = void 0;
var _accessibility = require("../constants/accessibility");
/**
 * This method takes the tokenizedString, values as a parameter,
 * return the updated tokenized string
 * @param  {String} tokenizedString - gets slide %x of %totalLength from CMS
 * @param  {Array} values - [array index count starts with 1, total length of array]
 */
const handleTokenizedString = function (tokenizedString) {
  let values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (!tokenizedString) {
    return null;
  }
  if (!values || tokenizedString && !tokenizedString.includes('%')) {
    return tokenizedString;
  }
  let tokenizedValue = tokenizedString;
  values.forEach((val, index) => {
    let token = `%${index + 1}`;
    tokenizedValue = tokenizedValue.replace(token, val);
  });
  return tokenizedValue;
};

/**
 * Function to handle keyboard focus when navigating through the slides with the previous/next buttons
 * @function handleSlideFocus
 * @param { string } data - returns the string to be passed as slidesPerGroup for LG breakpoint
 */
exports.handleTokenizedString = handleTokenizedString;
const handleSlideFocus = data => {
  const {
    swiper
  } = data;
  const activeIndex = swiper.activeIndex;
  const activeSlide = swiper.slides[activeIndex];
  if (activeSlide) {
    // Set tabindex on the slide to make it focusable
    activeSlide.setAttribute('tabindex', '-1');
    // Focus the active slide, preventing the browser from scrolling to it,
    // which can interfere with Swiper's own scroll management.
    activeSlide.focus({
      preventScroll: true
    });
  }
};

/**
 * This method to hide the inactive swiper slides and not to get the focus for child focusable elements
 * Add aria-hidden to true for swipers which are not in viewport
 * Add tabindex to -1 for child focusable elements of swiper slide which are not in viewport
 * @function handleInactiveSwiperSlides
 * @param { object } data - swiper slides
 */
exports.handleSlideFocus = handleSlideFocus;
const handleInactiveSwiperSlides = data => {
  const {
    slides,
    visibleSlides
  } = data || {};
  if (!slides || !visibleSlides) {
    return;
  }
  slides.forEach(item => {
    item.setAttribute('aria-hidden', 'true');
    const focusableElements = item.querySelectorAll(_accessibility.FOCUSABLE_ELEMENT_SELECTORS.join(', '));
    focusableElements.forEach(item => manageTabIndex(item, 'set'));
  });
  visibleSlides.forEach(item => {
    item.removeAttribute('aria-hidden');
    const focusableElements = item.querySelectorAll(_accessibility.FOCUSABLE_ELEMENT_SELECTORS.join(','));
    focusableElements.forEach(item => manageTabIndex(item, 'remove'));
  });
};

/**
 * Helper function to manage tabindex
 * @function manageTabIndex
 * @param { object } action - add or remove action
 * @param { object } buttonElement - element to remove/add to tab index
 */
exports.handleInactiveSwiperSlides = handleInactiveSwiperSlides;
const manageTabIndex = (buttonElement, action) => {
  if (!buttonElement) {
    return;
  }
  if (action === 'set') {
    buttonElement.setAttribute('tabindex', '-1');
  } else if (action === 'remove') {
    buttonElement.removeAttribute('tabindex');
  }
};

/**
 * Function for get slidesPerGroup for XL breakpoint
 * @function getSlidesPerGroupXL
 * @param { string } data - returns the string to be passed as slidesPerGroup for XL breakpoint
 */
exports.manageTabIndex = manageTabIndex;
const getSlidesPerGroupXL = data => {
  const {
    slidesPerGroupXL
  } = data;
  let setSlidesPerGroupXL;
  if (slidesPerGroupXL) {
    setSlidesPerGroupXL = slidesPerGroupXL;
  } else {
    setSlidesPerGroupXL = 4;
  }
  return setSlidesPerGroupXL;
};

/**
 * Function for get slidesPerGroup for LG breakpoint
 * @function getSlidesPerGroupLG
 * @param { string } data - returns the string to be passed as slidesPerGroup for LG breakpoint
 */
exports.getSlidesPerGroupXL = getSlidesPerGroupXL;
const getSlidesPerGroupLG = data => {
  const {
    isHighlighter,
    slidesHighlightPerGroupLG,
    slidesPerGroupLG
  } = data;
  let setSlidesPerGroupLG;
  if (isHighlighter) {
    setSlidesPerGroupLG = slidesHighlightPerGroupLG;
  }
  if (slidesPerGroupLG) {
    setSlidesPerGroupLG = slidesPerGroupLG;
  } else {
    setSlidesPerGroupLG = 3;
  }
  return setSlidesPerGroupLG;
};

/**
 * Function for get slidesPerGroup for MD breakpoint
 * @function getSlidesPerGroupMD
 * @param { string } data - returns the string to be passed as slidesPerGroup for MD breakpoint
 */
exports.getSlidesPerGroupLG = getSlidesPerGroupLG;
const getSlidesPerGroupMD = data => {
  const {
    slidesPerGroupMD
  } = data;
  let setSlidesPerGroupMD;
  if (slidesPerGroupMD) {
    setSlidesPerGroupMD = slidesPerGroupMD;
  } else {
    setSlidesPerGroupMD = 3;
  }
  return setSlidesPerGroupMD;
};

/**
 * Function for get slidesPerGroup for SM breakpoint
 * @function getSlidesPerGroupSM
 * @param { string } data - returns the string to be passed as slidesPerGroup for SM breakpoint
 */
exports.getSlidesPerGroupMD = getSlidesPerGroupMD;
const getSlidesPerGroupSM = data => {
  const {
    slidesPerGroupSM
  } = data;
  let setSlidesPerGroupSM;
  if (slidesPerGroupSM) {
    setSlidesPerGroupSM = slidesPerGroupSM;
  } else {
    setSlidesPerGroupSM = 1;
  }
  return setSlidesPerGroupSM;
};

/**
 * Function for get slidesPerView for XL breakpoint
 * @function getSlidesPerViewXL
 * @param { string } data - returns the string to be passed as slidesPerView for XL breakpoint
 */
exports.getSlidesPerGroupSM = getSlidesPerGroupSM;
const getSlidesPerViewXL = data => {
  const {
    isSingleItem,
    slidesPerViewAuto,
    sliderPerViewXL
  } = data;
  let setSlidesPerViewXL;
  if (isSingleItem) {
    setSlidesPerViewXL = 'auto';
  } else if (slidesPerViewAuto) {
    setSlidesPerViewXL = 'auto';
  } else if (sliderPerViewXL) {
    setSlidesPerViewXL = sliderPerViewXL;
  } else {
    setSlidesPerViewXL = 4;
  }
  return setSlidesPerViewXL;
};

/**
 * Function for get slidesPerView for LG breakpoint
 * @function getSlidesPerViewLG
 * @param { string } data - returns the string to be passed as slidesPerView for LG breakpoint
 */
exports.getSlidesPerViewXL = getSlidesPerViewXL;
const getSlidesPerViewLG = data => {
  const {
    isHighlighter,
    isSingleItem,
    sliderHighlightPerViewLG,
    slidesPerViewAuto,
    sliderPerViewLG
  } = data;
  let setSlidesPerViewLG;
  if (isSingleItem) {
    setSlidesPerViewLG = 'auto';
  } else if (isHighlighter) {
    setSlidesPerViewLG = sliderHighlightPerViewLG;
  } else if (slidesPerViewAuto) {
    setSlidesPerViewLG = 'auto';
  } else if (sliderPerViewLG) {
    setSlidesPerViewLG = sliderPerViewLG;
  } else {
    setSlidesPerViewLG = 3;
  }
  return setSlidesPerViewLG;
};

/**
 * Function for get slidesPerView for MD breakpoint
 * @function getSlidesPerViewMD
 * @param { string } data - returns the string to be passed as slidesPerView for MD breakpoint
 */
exports.getSlidesPerViewLG = getSlidesPerViewLG;
const getSlidesPerViewMD = data => {
  const {
    isSingleItem,
    slidesPerViewAuto,
    sliderPerViewMD
  } = data;
  let setSlidesPerViewMD;
  if (isSingleItem) {
    setSlidesPerViewMD = 'auto';
  } else if (slidesPerViewAuto) {
    setSlidesPerViewMD = 'auto';
  } else if (sliderPerViewMD) {
    setSlidesPerViewMD = sliderPerViewMD;
  } else {
    setSlidesPerViewMD = 3;
  }
  return setSlidesPerViewMD;
};

/**
 * Function for get slidesPerView for SM breakpoint
 * @function getSlidesPerViewSM
 * @param { string } data - returns the string to be passed as slidesPerView for SM breakpoint
 */
exports.getSlidesPerViewMD = getSlidesPerViewMD;
const getSlidesPerViewSM = data => {
  const {
    isSingleItem,
    slidesPerViewAuto,
    sliderPerViewSM
  } = data;
  let setSlidesPerViewSM;
  if (isSingleItem) {
    setSlidesPerViewSM = 'auto';
  } else if (slidesPerViewAuto) {
    setSlidesPerViewSM = 'auto';
  } else if (sliderPerViewSM) {
    setSlidesPerViewSM = sliderPerViewSM;
  } else {
    setSlidesPerViewSM = 1.6;
  }
  return setSlidesPerViewSM;
};
exports.getSlidesPerViewSM = getSlidesPerViewSM;